import React, {useEffect, useState} from 'react'
import {KTIcon} from '../../Ihouse/helpers'
import AddVoucherModal from '../Modals/AddVoucherModal'
import UpdateVoucherModal from '../Modals/UpdateVoucherModal'
import axios from '../../Helpers/Api_instance'
import Pagination from '../Pagination'
import {LazyLoadImage} from 'react-lazy-load-image-component'
import FeedbackModal from '../Modals/FeedbackModal'
export interface IAppProps {}

export default function FeedBackTable() {
  const [feedbacks, setFeedbacks] = useState([])
  const [id, setId] = useState('')
  const [pages, setPages] = useState(1)
  const [size, setSize] = useState(6)
  const [page, setPage] = useState(1)
  const [selectedData, setSelectedData] = useState({
    experience: '',
    rating: '',
    remark: '',
  })

  const getFeedbacks = async () => {
    try {
      const res = await axios.get(`/feedback?page=${page}&items=${size}`)
      if (res && res.data) {
        console.log('res.data', res.data)
        setFeedbacks(res.data.data)
      }
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getFeedbacks()
  }, [page, size])
  return (
    <>
      <div className='card mb-5 mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Customer Feedbacks</span>
          </h3>
          <div className='card-toolbar gap-3'>
            <div className='card-toolbar'></div>
          </div>
        </div>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            <table className='table align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bold text-muted bg-light'>
                  <th className='min-w-200px text-start ps-4'>Sl.No</th>
                  <th className='min-w-200px text-start ps-4'>OrderId</th>
                  <th className='min-w-150px text-start ps-4'>Customer Details</th>
                  <th className='min-w-150px text-start ps-4'>Rating</th>
                  <th className='min-w-200px text-center'>
                    <span className='w-100'>Actions</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {feedbacks.map((e: any, i) => {
                  return (
                    <tr key={i}>
                      <td className='text-start ps-4 '>
                        <a href='#' className='text-gray-900 fw-bold text-hover-primary mb-1 fs-6'>
                          {(page - 1) * size + i + 1}
                        </a>
                      </td>

                      <td className='text-start ps-4'>
                        <a
                          href='#'
                          className='text-gray-900 fw-bold text-hover-primary d-block mb-1 fs-6'
                        >
                          {e.order.reference_number}
                        </a>
                      </td>
                      <td>
                        <a
                          href='#'
                          className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'
                        >
                          {e?.order?.first_name + ' ' + e?.order?.last_name}
                        </a>
                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                          {e?.order?.mobile}
                        </span>
                      </td>

                      <td className='text-start ps-4'>
                        <a
                          href='#'
                          className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'
                        >
                          {new Array(e?.rating || 1).fill(null).map(() => {
                            return <KTIcon iconName='star' className='fs-3 text-warning' />
                          })}
                        </a>
                      </td>
                      <td className='d-flex justify-content-center'>
                        <button
                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          data-bs-toggle='modal'
                          data-bs-target='#feedbackModal'
                          onClick={() => {
                            setSelectedData({
                              experience: e.note,
                              rating: e.rating,
                              remark: e.remark,
                            })
                          }}
                        >
                          <KTIcon iconName='eye' className='fs-3' />
                        </button>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <FeedbackModal {...selectedData} />

      <Pagination
        page={page}
        pages={pages}
        pageChanger={(page) => {
          setPage(page)
        }}
      />
    </>
  )
}
